import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { SkipLink, SKIP_TARGET_ID } from './SkipLink';

export const AppLayout = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <SkipLink />
    <AppHeader />
    <Box
      component="main"
      id={SKIP_TARGET_ID}
      tabIndex={-1}
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        '&:focus-visible': {
          outline: 2,
          outlineColor: 'primary.main',
          outlineOffset: -2,
        },
      }}
    >
      <Outlet />
    </Box>
  </Box>
);
